/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AppConfig, Environment } from './app-config.model';
import { APP_VERSION } from './version.token';

export interface BackendConfig {
  version: string;
  profiles: string;
  hostAddress: string;
  hostname: string;
  mediaProxyUrl: string;
  documentationUrl: string;
  uploadUrl: string;
  staticFilesUrl: string;
  firebase: FirebaseConfig;
  googleAnalyticsId: string;
  helperUrl: string;
}

export interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

const ENV_MAPPING: Record<string, Environment> = {
  local: 'local',
  dev: 'dev',
  integration: 'int',
  production: 'prod',
};

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private appConfig?: AppConfig;
  private firebaseConfig?: FirebaseConfig;

  constructor(
    private http: HttpClient,
    @Inject(APP_VERSION) private version: string
  ) {}

  public getAppConfig = (): AppConfig => {
    if (!this.appConfig) {
      const backendConfig: BackendConfig = (window as any).backendConfig;
      const environment: Environment = ENV_MAPPING[backendConfig.profiles];
      this.appConfig = this.appConfig = {
        appVersion: this.version + '-' + environment,
        mediaApiUrl: backendConfig.mediaProxyUrl,
        fileApiUrl: backendConfig.documentationUrl,
        uploadUrlLambda: backendConfig.uploadUrl,
        imageApiUrl: backendConfig.staticFilesUrl,
        environment,
        firebase: backendConfig.firebase,
        googleAnalyticsId: backendConfig.googleAnalyticsId,
        helperUrl: backendConfig.helperUrl,
      };
    }
    return this.appConfig;
  };

  public getFirebaseConfig = (): FirebaseConfig => {
    if (!this.firebaseConfig) {
      const backendConfig: BackendConfig = (window as any).backendConfig;
      this.firebaseConfig = backendConfig.firebase;
    }
    return this.firebaseConfig;
  };
}
